import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { ToastItem, ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast-overlay',
  standalone: true,
  imports: [NgClass],
  templateUrl: './toast-overlay.component.html',
  styleUrl: './toast-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastOverlayComponent {
  readonly toastService = inject(ToastService);

  removeToast(id: number): void {
    this.toastService.remove(id);
  }

  trackById(_index: number, toast: ToastItem): number {
    return toast.id;
  }
}
